import styled from "styled-components";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import TitleBar from "../../../helperComponents/TitleBar";
import LoggedInMembershipPlans from "./LoggedInMembershipPlans";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 62vw;
  align-items: center;
  gap: 50px;

  @media (max-width: 900px) {
    width: 90vw;
  }
`;

export default function LoggedInMembershipPage() {
  const { t } = useTranslation();

  return (
    <LoggedInBoilerplate showBackgroundImage={true}>
      <TitleBar>{t("membership")}</TitleBar>

      <Container>
        <LoggedInMembershipPlans />
      </Container>
      <br />
    </LoggedInBoilerplate>
  );
}
